<template>
    <div class='container'>
        <protocol-content :protocol='protocol'/>
    </div>
</template>

<script>
    import ProtocolContent from './_protocol'
    import { EARNEST_PROTOCOL } from '@/clause/protocol/earnest'
    import { DISPOSAL_PROTOCOL } from '@/clause/protocol/disposal'
    import { CONTRACT_TEMPLATE } from '@/clause/protocol/contract'
    import { BOOKING_PROTOCOL } from '@/clause/protocol/booking'

    export default {
        components: {
            ProtocolContent
        },
        data () {
            return {
                protocol: EARNEST_PROTOCOL,
                protocols: {
                    earnest: EARNEST_PROTOCOL,
                    disposal: DISPOSAL_PROTOCOL,
                    contract: CONTRACT_TEMPLATE,
                    booking: BOOKING_PROTOCOL
                }
            }
        },
        created () {
            this.protocol = this.protocols[this.$route.params.name]
        }
    }
</script>
